module.exports = "https://cdn2-fs.clearscore.com/flux/images/8382a56376cad738a39b107c31413ba7.jpg";